import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Particle from "../Particle";
// import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>
              <h1 className="heading-name">
                I'M
                <strong className="main-name"> Hamza Ayoub</strong>
              </h1>
              <p className="heading-paragraph">
                As a Software Engineering graduate (2018-2022) with a CGPA of
                3.71/4.0, I bring both academic excellence and practical
                experience to the table. Over the past two years, I have delved
                deep into the world of web development, focusing on honing my
                skills in React.js, Next.js, Node.js, Express.js, MongoDB,
                Bootstrap, JavaScript, TypeScript, TailwindCSS, Material UI,
                jQuery, MySql, PostgreSql, PHP, and a plethora of other
                technologies. My passion lies in crafting robust and
                user-centric web solutions that seamlessly blend creativity with
                coding proficiency. With a strong foundation in software
                engineering principles and a keen eye for detail, I am adept at
                creating scalable applications that meet the needs of both
                clients and end-users alike. I thrive in collaborative
                environments and am always eager to apply my expertise in
                problem-solving and software development to tackle new
                challenges head-on. My dedication to continuous learning ensures
                that I stay abreast of the latest technologies and best
                practices, making me a valuable asset to any team.{" "}
              </p>

              <div style={{ paddingLeft: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingTop: 30 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "480px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      {/* <Home2 /> */}
    </section>
  );
}

export default Home;
